import React from "react";
import ActionIcon from "./components/ActionIcon";

const cellRender = ({ data, context }) => {
  return (
    <ActionIcon
      click={(e) => {
        e.preventDefault();
        context.componentParent.removeLine(data);
      }}
      icon={"icon-subtract"}
    />
  );
};

export const RemoveLineFromAsn = {
  headerName: "Remove",
  cellRendererFramework: cellRender,
  cellStyle: { display: "flex", "justify-content": "center" },
  width: 90,
  sortable: false,
  suppressSizeToFit: true,
};
